import { useContext } from "react";
import { AlertModalContext } from "./context";

export const useAlertModal = () => {
  return useContext(AlertModalContext);
};
